<template>
  <div class="error-container">
    <div class="error-code">500</div>
    <p class="error-message">
      服务器后端异常，请稍后重试！
<!--      <span style="color: #3a8ee6">{{time}}s</span>后返回上一页-->
    </p>
    <div class="error-animation">
      <img :src="src" style="width: 200px">
    </div>
  </div>
</template>

<script>
import error from '../image/error.png'
export default {
  name:'LEServerError',
  data(){
    return{
      src:error,
      time:3,
      timer:null,
    }
  },
  created() {
    // this.minute()
  },
  methods:{
    back(){
      history.back()
    },
    minute() {
      this.timer = setInterval(() => {
        --this.time
        if (this.time <= 0) {
          this.clearTimer()  // 达到条件时清除
          this.back()
        }
      }, 1000)
    },
    clearTimer(){
      if (this.timer){
        clearTimeout(this.timer)
        this.timer = null
      }
    }

  }
}
</script>

<style scoped>
.error-container {
  margin: auto;
  max-width: 800px;
  width: 100%;
  text-align: center;
  padding: 40px;
  border-radius: 20px;
}

.error-code {
  font-size: 100px;
  font-weight: 500;
  color: #aeb1b4;
  margin-bottom: 20px;
  line-height: 1;
}


.error-message {
  font-size: 18px;
  margin-bottom: 30px;
  color: #666;
  line-height: 1.6;
}

.error-animation {
  margin: 30px auto;
  max-width: 300px;
}

@keyframes float {
  0% { transform: translateY(0px); }
  50% { transform: translateY(-20px); }
  100% { transform: translateY(0px); }
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
}

@media (max-width: 600px) {
  .error-code {
    font-size: 80px;
  }
}
</style>
